import { createFileRoute } from "@tanstack/react-router";
import { LinkedAccountsPage } from "./-linked-accounts-page";
import { useBreadCrumbs } from "~/contexts/useBreadCrumbs";
import { z } from "zod";

export const Route = createFileRoute("/_dashboard/$datasetSlug/settings/linked-accounts/")({
  validateSearch: z.object({
    code: z.string().optional().catch(undefined),
    error: z.string().optional().catch(undefined),
  }),
  component: RouteComponent,
});

function RouteComponent() {
  useBreadCrumbs([
    { title: "Communication and Storage", link: `/${location.pathname.split("/")[1]}/settings/linked-accounts` },
  ]);
  return <LinkedAccountsPage />;
}
